import { render, staticRenderFns } from "./ApplyRoomTypeComponent.vue?vue&type=template&id=4fba936f&scoped=true"
import script from "./ApplyRoomTypeComponent.vue?vue&type=script&lang=js"
export * from "./ApplyRoomTypeComponent.vue?vue&type=script&lang=js"
import style0 from "./ApplyRoomTypeComponent.vue?vue&type=style&index=0&id=4fba936f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba936f",
  null
  
)

export default component.exports